module.exports = __webpack_public_path__ + "img/no-result.37780208.svg";